// Cooldown before re-syncing the API with external data.
export const SYNC_COOLDOWN_MS = 5000;

// Interval for the background actionable-data refresh.
export const SYNC_REFRESH_INTERVAL_MS = 300000;

// Service-worker update check interval — deliberately independent of the data refresh.
export const SW_UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Which source prices a stock. The API stores and returns the same two names.
export const PRICING_MODE = {
    DELAYED: 'delayed',
    REALTIME: 'realtime',
};
